<template>
  <portal to="modal">
    <transition name="zoom-fade">
      <div class="fixed z-99999 left-0 top-0 w-full h-full overflow-y-scroll overflow-x-hidden" @scroll="handleScroll">
        <div class="fixed left-0 top-0 w-full h-full" :class="[bgBackdrop, bgOpacity, {'bg-blur' : blur}]" />
        <div :class="{'yes-modal-centered' : centered}">
          <div
            class="card w-full rounded-12 shadow-lg relative z-99999 my-6 md:mx-auto mx-4"
            :class="[lg ? '2xl:w-1/2 lg:w-2/3 md:w-3/4' : sm ? '2xl:w-1/4 xl:w-2/4 lg:w-1/3 md:w-3/4' :
                       fullwidth ? 'w-full': dialogClass !== '' ? dialogClass :'xl:w-2/5 lg:w-1/2 md:w-3/4',
                     textCenter ? 'text-center' : ''
            ]"
          >
            <div v-if="imageModal" class="yes-modal-image" :class="{'justify-center align-center': imgCenter}">
              <slot name="image" />
            </div>
            <div :class="[{'yes-modal-title': title}, {'mb-4': showClose && !title}]">
              <slot name="title">
                <h4>
                  {{ title }}
                </h4>
              </slot>
              <button
                v-if="showClose"
                type="button"
                class="el-dialog__headerbtn top-3"
                aria-label="Close"
                @click="handleClose"
              >
                <i class="el-dialog__close el-icon el-icon-close font-black text-xl" />
              </button>
            </div>
            <template v-if="$slots.default">
              <div class="yes-modal-content">
                <slot />
              </div>
            </template>
          </div>
        </div>
      </div>
    </transition>
  </portal>
</template>

<script>
export default {
  name: 'YesModal',
  props: {
    title: {
      type: String,
      default: ''
    },
    dialogClass: {
      type: String,
      default: ''
    },
    bgBackdrop: {
      type: String,
      default: 'bg-white'
    },
    bgOpacity: {
      type: String,
      default: 'bg-opacity-70'
    },
    showClose: {
      type: Boolean,
      default: false
    },
    blur: {
      type: Boolean,
      default: false
    },
    centered: {
      type: Boolean,
      default: false
    },
    imgCenter: {
      type: Boolean,
      default: false
    },
    imageModal: {
      type: Boolean,
      default: true
    },
    textCenter: {
      type: Boolean,
      default: false
    },
    fullwidth: {
      type: Boolean,
      default: false
    },
    lg: {
      type: Boolean,
      default: false
    },
    sm: {
      type: Boolean,
      default: false
    }
  },
  created () {
    if (process.client) {
      // eslint-disable-next-line nuxt/no-globals-in-created
      document.addEventListener('keyup', this.onClose)
    }
  },
  destroyed () {
    // eslint-disable-next-line nuxt/no-env-in-hooks
    if (process.client) {
      // eslint-disable-next-line nuxt/no-globals-in-created
      document.addEventListener('keyup', this.onClose)
    }
  },
  methods: {
    handleClose () {
      this.$emit('close')
    },
    onClose (event) {
      // Escape key
      if (event.keyCode === 27) {
        this.handleClose()
      }
    },
    handleScroll (event) {
      this.$emit('scroll', event)
    }
  }
}
</script>

<style scoped lang="scss">
  .yes-modal-image {
    display: flex;
    padding: 1rem;
  }
  .yes-modal-centered {
    display: flex;
    align-items: center;
    min-height: calc(100% - 1rem);
    position: relative;

    @media screen and (min-width: 768px) {
      min-height: calc(100% - 3.5rem);
    }
  }
  .yes-modal-title {
    margin-bottom: 1rem;
  }
  .bg-blur {
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
  }
</style>
